// extracted by mini-css-extract-plugin
export default {"incoming-call":"incoming-call--2D2eK","actions":"actions--14j28"};